import {
  Box,
  HStack,
  Icon,
  Show,
  Text,
  ThemeColorPath,
  ThemeColorTextPath,
  ThemeIconKey,
} from 'platform/foundation';
import {match} from 'ts-pattern';

import {TestIdProps} from 'shared/web';

import {PriceBadgeTone} from '../types/PriceBadgeTone';

interface PriceBadgeProps extends TestIdProps {
  label: string;
  tone: PriceBadgeTone;
  icon?: ThemeIconKey;
}

/** A pill on the dark price card; light fills keep the label readable against the dark ground. */
export function PriceBadge(props: PriceBadgeProps) {
  const colors = match(props.tone)
    .returnType<{background: ThemeColorPath; text: ThemeColorTextPath}>()
    .with('positive', () => ({background: 'palettes.green.20.100', text: 'success'}))
    .with('warning', () => ({background: 'palettes.orange.20.100', text: 'warning'}))
    .with('danger', () => ({background: 'palettes.red.20.100', text: 'danger'}))
    .with('muted', () => ({background: 'palettes.neutral.40.100', text: 'secondary'}))
    .exhaustive();

  return (
    <Box
      backgroundColor={colors.background}
      borderRadius="circular"
      maxWidth="100%"
      paddingHorizontal={3}
      paddingVertical={1}
    >
      <HStack spacing={1} align="center" minWidth={0}>
        <Show when={props.icon}>
          {(icon) => <Icon value={icon} size={4} color={`text.${colors.text}`} />}
        </Show>
        <Text
          size="xSmall"
          color={colors.text}
          alternative
          noWrap
          data-testid={props['data-testid']}
        >
          {props.label}
        </Text>
      </HStack>
    </Box>
  );
}
